<div class="notification-container">
    <div class="notification-dialog">
        <div class="header-section">
            <div class="close-button-container">
                <button (click)="onClose()" class="close-button" aria-label="Close notification">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                        class="close-icon">
                        <path d="M18 6L6 18M6 6L18 18" stroke="#232529" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </button>
            </div>
        </div>

        <div class="image-container">
            <img src=".../../../../../../../assets/images/send.png" alt="notification_image"
                class="notification-image" />
        </div>

        <h2 class="notification-title">
            {{ message }}
        </h2>

        <p class="notification-message">
            {{ 'Catalogs.catalog_shared_message' | translate }}
        </p>

        <div class="button-container">
            <button (click)="onDone()" class="done-button">
                {{ 'common.done' | translate }}
            </button>
        </div>
    </div>
</div>
